import React, { useEffect, useState } from "react";
import { Box, ImageList, ImageListItem, Modal, Skeleton } from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isArray } from "jquery";
import VideoPreviewComponent from "../../component/admin/modalsComponents/VideoPreviewComponet";

const itemData = [
  {
    img: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e",
    title: "Breakfast",
  },
  {
    img: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d",
    title: "Burger",
  },
  {
    img: "https://images.unsplash.com/photo-1522770179533-24471fcdba45",
    title: "Camera",
  },
  {
    img: "https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c",
    title: "Coffee",
  },
  {
    img: "https://images.unsplash.com/photo-1533827432537-70133748f5c8",
    title: "Hats",
  },
  {
    img: "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62",
    title: "Honey",
  },
  {
    img: "https://images.unsplash.com/photo-1516802273409-68526ee1bdd6",
    title: "Basketball",
  },
  {
    img: "https://images.unsplash.com/photo-1518756131217-31eb79b20e8f",
    title: "Fern",
  },
  {
    img: "https://images.unsplash.com/photo-1597645587822-e99fa5d45d25",
    title: "Mushrooms",
  },
  {
    img: "https://images.unsplash.com/photo-1567306301408-9b74779a11af",
    title: "Tomato basil",
  },
  {
    img: "https://images.unsplash.com/photo-1471357674240-e1a485acb3e1",
    title: "Sea star",
  },
  {
    img: "https://images.unsplash.com/photo-1589118949245-7d38baf380d6",
    title: "Bike",
  },
];

const ProfessionalVideoView = ({ setOpen, open, selected }) => {
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchProfessionalGoalVideos = async (id, token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_USER}/getProfessionalTournament/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //   return response.data;
      // "";
      if (response.data.success) {
        setGoals(response.data?.data?.professionalTournamentGoals);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Error !!");
      }
    } catch (e) {
      toast.error("Error !!");
    }
  };

  useEffect(() => {
    if (open && token && selected.current?.id) {
      setLoading(true);
      fetchProfessionalGoalVideos(selected.current.id, token);
    }
  }, [open]);

  // "";

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="view-professional-goal-modal">
          <Box className="professional-video-wrapper">
            <Box className="video-grid">
              {loading
                ? Array.from({ length: 10 }).map(() => (
                    <Skeleton
                      height={"100%"}
                      width={"100%"}
                      variant="rectangular"
                    />
                  ))
                : isArray(goals) && goals.length > 0
                ? goals.map((ele) => <VideoPreviewComponent videoFile={ele} />)
                : "No Videos"}
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ProfessionalVideoView;
